module.exports = __webpack_public_path__ + "static/media/Dagmara Szkurlat.1b9231eb.png";